"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverTypesDescription = void 0;
const Object_1 = require("../type-descriptions/Object");
const ValidationResult_1 = require("../type-descriptions/ValidationResult");
const exists_1 = __importDefault(require("../util/exists"));
const TripType_1 = require("./TripType");
exports.driverTypesDescription = {
    userFacingTitle: 'service types',
    userFacingValue: types => Object.entries(types)
        .filter(([key, value]) => value)
        .map(([key]) => (0, TripType_1.tripTypeTitle)(key))
        .join(', '),
    validate: value => (0, ValidationResult_1.validationResultTry)(Object_1.objectDescription.validate(value), object => {
        for (const tripType of TripType_1.tripTypeAllKnown) {
            if ((0, exists_1.default)(object[tripType]) && typeof object[tripType] !== 'boolean') {
                throw new Error(`Driver type "${tripType}" is not a boolean: "${object[tripType]}"`);
            }
        }
        return object;
    }),
};
